import { useNavigate } from "react-router-dom";
import { ButtonCustom } from "../../Atoms/ButtonCustom/buttonCustom";
import { IconCheck } from "./icon/iconCheck";
import * as S from "./styles";

export const StatusSuccessPage = () => {
  const navigate = useNavigate();
  return (
    <S.Container>
      <S.Content>
        <div>
          <IconCheck />
        </div>

        <div>
          <h1>Sua denúncia foi registrada com sucesso.</h1>
        </div>

        <div>
          <p>
            Agradecemos por sua iniciativa em relatar esta situação. Sua
            denúncia foi recebida e será tratada com total sigilo e seriedade.
            Nossa equipe especializada analisará as informações e tomará as
            providências necessárias com o máximo de responsabilidade.
          </p>
        </div>

        <div>
          <p>
            Estamos aqui para garantir um ambiente seguro e respeitoso para
            todos..
          </p>
        </div>

        <div>
          <ButtonCustom onClick={() => navigate("/")}>
            Voltar para Home
          </ButtonCustom>
        </div>
      </S.Content>
    </S.Container>
  );
};
